<template>
  <v-card
    class="w-50 py-8 px-6 text-center"
    elevation="0">
    <v-card-title> ワンタイムパスワード認証 </v-card-title>

    <v-alert
      type="info"
      variant="tonal"
      class="mb-8 text-left">
      Google Authenticatorにワンタイムパスワードを送信しました。<br />
      ワンタイムパスワードを入力してください。
    </v-alert>

    <!-- エラーメッセージ -->
    <v-alert
      v-if="props.error"
      type="error"
      variant="tonal"
      class="mb-8 text-left">
      {{ props.error }}
    </v-alert>

    <v-form @submit.prevent="submitPassword">
      <v-otp-input
        v-model="totp"
        variant="outlined"
        length="6"></v-otp-input>

      <v-btn
        :loading="loading"
        type="submit"
        class="my-4"
        width="70%"
        variant="flat"
        color="primary"
        size="large">
        認証
      </v-btn>
    </v-form>
  </v-card>
</template>

<script setup lang="ts">
import { ref } from 'vue';

const props = defineProps({
  loading: Boolean,
  error: String
});

const emit = defineEmits<{
  submit: [password: string];
}>();

let totp = ref('');

let loading = false;

function submitPassword() {
  loading = true;
  emit('submit', totp.value);
  loading = false;
}
</script>
